import { authenticateRequest } from '@api/authenticateRequest';

import type { operations } from '@type/model';
import type { OmitGroupIdInHeader } from '@type/util';

type ResendFamilyEventMailPath =
  operations['AdminEventController_sendMailResend']['parameters']['path'];
type ResendFamilyEventMailHeaders =
  operations['AdminEventController_sendMailResend']['parameters']['header'];

interface ResendFamilyEventMailProps {
  path: ResendFamilyEventMailPath;
  headers?: OmitGroupIdInHeader<ResendFamilyEventMailHeaders>;
}

type ResendFamilyEventMailResponse = unknown;

export async function resendFamilyEventMail({
  path,
  headers,
}: ResendFamilyEventMailProps): Promise<ResendFamilyEventMailResponse | false> {
  const response = await authenticateRequest<ResendFamilyEventMailResponse>({
    method: 'post',
    url: `/api/v1/admin/events/${path.eventId}/mail-resend`,
    headers,
  });

  console.log('resendFamilyEventMail', { response });
  return response;
}
